import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const HIGHLIGHTS = [
  "Atendimento humano e familiar",
];

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1668036097078-6560f2ce2216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxkb2clMjBpbiUyMGZhcm0lMjBmaWVsZCUyMHN1bnNldHxlbnwwfHx8fDE3OTEyMjMyNDd8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-12 lg:grid-cols-2 lg:gap-20 lg:px-20">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div
            aria-hidden="true"
            className="absolute -left-6 -top-6 h-full w-full rounded-[2.5rem] rounded-tl-[5rem] border-2 border-clay/30"
          />
          <div className="relative overflow-hidden rounded-[2.5rem] rounded-tl-[5rem] shadow-2xl shadow-olive/20">
            <img
              src={ABOUT_IMAGE}
              alt="Cão da família Carmo no campo ao entardecer"
              loading="lazy"
              data-testid="about-image"
              className="h-[26rem] w-full object-cover sm:h-[30rem]"
            />
          </div>
          <div className="absolute -bottom-6 right-6 rounded-2xl bg-olive px-6 py-4 text-parchment shadow-xl">
            <p className="font-display text-3xl font-semibold">2026</p>
            <p className="text-xs text-parchment/70">o ano em que tudo começou</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-clay">
            Nossa história
          </p>
          <h2 className="font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Uma casa de rações que virou <em className="not-italic text-olive">ponto de encontro</em>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-moss sm:text-lg">
            A Agro Carmo nasceu como uma pequena casa de rações e cresceu junto com a cidade. Hoje
            somos referência em nutrição animal, petshop e suprimentos para o campo — mas o jeito de
            atender continua o mesmo: nome pelo nome, cafezinho na conversa e palavra dada é palavra
            cumprida.
          </p>
          <ul className="mt-8 space-y-4">
            {HIGHLIGHTS.map((item) => (
              <li key={item} className="flex items-center gap-3 text-base text-ink">
                <BadgeCheck className="h-5 w-5 shrink-0 text-clay" />
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-10 font-display text-2xl italic text-olive">— Família Carmo</p>
        </motion.div>
      </div>
    </section>
  );
}
